import { render, staticRenderFns } from "./AdminCatalog.vue?vue&type=template&id=1473471b&scoped=true"
import script from "./AdminCatalog.vue?vue&type=script&lang=js"
export * from "./AdminCatalog.vue?vue&type=script&lang=js"
import style0 from "./AdminCatalog.vue?vue&type=style&index=0&id=1473471b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473471b",
  null
  
)

export default component.exports